import { showSuccessMessage, showErrorMessage } from "@global";
import {
  SET_QUOTES
} from '@actions/types';
import {
  getAPIRequest,
  postAPIRequest
} from '@actions';

export const getQuotes = (onSuccess) => {
  return (dispatch) => {
    console.log("hello");
    dispatch(
      getAPIRequest(
        '/admin/get_quotes',
        {},
        response => {
          dispatch({ type: SET_QUOTES, payload: { richQuotes: response.rich_quotes, otherQuotes: response.other_quotes }});
          onSuccess();
        },
        error => {
          //onFail(error.error);
        },
      ),
    );
  }
};

export const addQuote = (data, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/add_quote',
        data,
        response => {
          dispatch({ type: SET_QUOTES, payload: { richQuotes: response.rich_quotes, otherQuotes: response.other_quotes }});
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const editQuote = (data, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/edit_quote',
        data,
        response => {
          dispatch({ type: SET_QUOTES, payload: { richQuotes: response.rich_quotes, otherQuotes: response.other_quotes }});
          onSuccess();
        },
        error => {
          onFail(error.error);
        },
      ),
    );
  };
};

export const deleteQuote = (data, onSuccess, onFail) => {
  return (dispatch) => {
    dispatch(
      postAPIRequest(
        '/admin/delete_quote',
        data,
        response => {
          dispatch({ type: SET_QUOTES, payload: { richQuotes: response.rich_quotes, otherQuotes: response.other_quotes }});
          onSuccess();
        },
        error => {
          console.log(error.error);
          onFail(error.error);
        },
      ),
    );
  };
};
